<template>
  <div>
    <!-- <div class="like_share_wrap b-0">
      <ul class="like_share_list">
        <li>
          <router-link to="" class="btn btn-likes"
            ><i class="fas fa-share"></i>Share</router-link
          >
        </li>
        <li>
          <router-link to="" class="btn btn-likes"
            ><i class="fas fa-heart"></i>Save</router-link
          >
        </li>
      </ul>
    </div> -->
    <div class="details-sidebar">
      <div class="sides-widget">
        <div class="sides-widget-header bg-primary">
          <div class="agent-photo"><img :src="user1" alt="" /></div>
          <div class="sides-widget-details">
            <h4><router-link to="#">Contact Us</router-link></h4>
            <span><i class="lni-phone-handset"></i>(+1) 506 889 7999</span>
          </div>
          <div class="clearfix"></div>
        </div>

        <div class="sides-widget-body simple-form">
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              v-model="name"
              :class="{ 'is-invalid': errors.name }"
            />
            <!-- Apply inline style to force display -->
            <div
              v-if="errors.name"
              class="invalid-feedback"
              style="
                display: block;
                color: #dc3545;
                font-size: 0.875em;
                margin-top: 0.25rem;
              "
            >
              {{ errors.name }}
            </div>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              class="form-control"
              v-model="email"
              :class="{ 'is-invalid': errors.email }"
            />
            <!-- Apply inline style to force display -->
            <div
              v-if="errors.email"
              class="invalid-feedback"
              style="
                display: block;
                color: #dc3545;
                font-size: 0.875em;
                margin-top: 0.25rem;
              "
            >
              {{ errors.email }}
            </div>
          </div>
          <div class="form-group">
            <label>Phone No.</label>
            <input
              type="text"
              class="form-control"
              v-model="phone"
              @input="formatPhoneNumber"
              :class="{ 'is-invalid': errors.phone }"
            />
            <!-- Apply inline style to force display -->
            <div
              v-if="errors.phone"
              class="invalid-feedback"
              style="
                display: block;
                color: #dc3545;
                font-size: 0.875em;
                margin-top: 0.25rem;
              "
            >
              {{ errors.phone }}
            </div>
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea
              v-model="message"
              class="form-control"
              placeholder="I'm interested in this property."
            ></textarea>
          </div>

          <div class="form-group">
            <label>Do you have pets?</label>
            <div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="pets-yes-sidebar" value="yes" v-model="pets">
                <label class="form-check-label" for="pets-yes-sidebar">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="pets-no-sidebar" value="no" v-model="pets">
                <label class="form-check-label" for="pets-no-sidebar">No</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Are you employed?</label>
            <div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="working-yes-sidebar" value="yes" v-model="isWorking">
                <label class="form-check-label" for="working-yes-sidebar">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="working-no-sidebar" value="no" v-model="isWorking">
                <label class="form-check-label" for="working-no-sidebar">No</label>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="isWorking === 'yes'">
            <label>Employer Name</label>
            <input
              type="text"
              class="form-control"
              v-model="employerDetails"
              placeholder="Enter your employer name"
            />
          </div>
          <div class="form-group form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="gdprAgreement"
              v-model="gdprAgreement"
            />
            <label class="form-check-label" for="gdprAgreement">
              I agree to the terms and conditions
            </label>
            <div
              v-if="errors.gdpr"
              class="invalid-feedback"
              style="
                display: block;
                color: #dc3545;
                font-size: 0.875em;
                margin-top: 0.25rem;
              "
            >
              {{ errors.gdpr }}
            </div>
          </div>
          <button
            @click="sendMessage"
            class="btn btn-light-primary fw-medium rounded full-width"
            :disabled="isSending"
          >
            <span
              v-if="isSending"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-else>Send Message</span>
          </button>
        </div>
        <div class="px-3 py-2">
          <div class="teamgrid-social">
            <ul>
              <li>
                <a href="https://www.facebook.com/rent99pm/" class="f-cl"
                  ><i class="fa-brands fa-facebook"></i
                ></a>
              </li>
              <li>
                <a href="https://www.youtube.com/@realtorravithota" class="y-cl"
                  ><i class="fa-brands fa-youtube"></i
                ></a>
              </li>
              <li>
                <a href="https://www.instagram.com/realtorravi/" class="i-cl"
                  ><i class="fa-brands fa-instagram"></i
                ></a>
              </li>
              <li>
                <a href="https://wa.me/+15062333999" class="l-cl"
                  ><i class="fa-brands fa-whatsapp"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="sides-widget">
        <div class="sides-widget-header bg-primary">
          <div class="sides-widget-details">
            <h4>Mortgage Calculator</h4>
            <span>View your Interest Rate</span>
          </div>
          <div class="clearfix"></div>
        </div>

        <div class="sides-widget-body simple-form">
          <div class="form-group">
            <div class="input-with-icon">
              <input
                type="text"
                class="form-control"
                placeholder="Sale Price"
              />
              <i class="fa-solid fa-sack-dollar"></i>
            </div>
          </div>

          <div class="form-group">
            <div class="input-with-icon">
              <input
                type="text"
                class="form-control"
                placeholder="Down Payment"
              />
              <i class="fa-solid fa-piggy-bank"></i>
            </div>
          </div>

          <div class="form-group">
            <div class="input-with-icon">
              <input
                type="text"
                class="form-control"
                placeholder="Loan Term (Years)"
              />
              <i class="fa-regular fa-calendar-days"></i>
            </div>
          </div>

          <div class="form-group">
            <div class="input-with-icon">
              <input
                type="text"
                class="form-control"
                placeholder="Interest Rate"
              />
              <i class="fa fa-percent"></i>
            </div>
          </div>
          <button class="btn btn-light-primary fw-medium rounded full-width">
            Calculate
          </button>
        </div>
      </div> -->

      <!-- <div class="sidebar-widgets"> -->
      <!-- <h4>Featured Property</h4> -->

      <!-- <div class="sidebar_featured_property">
          <div
            v-for="(item, index) in featureProperty"
            :key="index"
            class="sides_list_property"
          >
            <div class="sides_list_property_thumb">
              <img :src="item.image" class="img-fluid" alt="" />
            </div>
            <div class="sides_list_property_detail">
              <h4>
                <router-link to="/single-property-1">{{
                  item.name
                }}</router-link>
              </h4>
              <span
                ><i class="fa-solid fa-location-dot"></i
                >{{ item.location }}</span
              >
              <div class="lists_property_price">
                <div class="lists_property_types">
                  <div
                    v-if="item.type === 'For Sale'"
                    class="property_types_vlix sale"
                  >
                    For Sale
                  </div>
                  <div
                    v-if="item.type === 'For Rent'"
                    class="property_types_vlix"
                  >
                    For Rent
                  </div>
                  <div
                    v-if="item.type === 'For Buy'"
                    class="property_types_vlix buy"
                  >
                    For Buy
                  </div>
                </div>
                <div class="lists_property_price_value">
                  <h4>$4,240</h4>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const props = defineProps({
  property: Object,
});

// Form state
const name = ref("");
const email = ref("");
const phone = ref("");
const message = ref("");
const gdprAgreement = ref(false);
const errors = ref({});
const isSending = ref(false);
const pets = ref(null);
const isWorking = ref(null);
const employerDetails = ref("");


// 1. Add this function to filter phone number input
const formatPhoneNumber = (event) => {
  const formatted = event.target.value.replace(/[^0-9]/g, "");
  phone.value = formatted;
};

// Method to send a message
const sendMessage = async () => {
  console.log("Property :", props.property);
  // 1. Add a guard to ensure property data is loaded
  if (!props.property) {
    Swal.fire({
      title: "Please Wait",
      text: "Property details are still loading. Please try again in a moment.",
      icon: "info",
      confirmButtonText: "OK",
    });
    return;
  }

  // 2. Perform inline validation
  errors.value = {};
  if (!name.value.trim()) errors.value.name = "Name is required.";
  if (!email.value.trim()) errors.value.email = "Email is required.";
  else if (!/^\S+@\S+\.\S+$/.test(email.value))
    errors.value.email = "Please enter a valid email address.";

  if (!phone.value.trim()) {
    errors.value.phone = "Phone number is required.";
  } else if (phone.value.length < 10) {
    errors.value.phone =
      "Please enter a valid phone number (at least 10 digits).";
  }

  if (!gdprAgreement.value)
    errors.value.gdpr = "You must consent to the terms.";

  if (Object.keys(errors.value).length > 0) {
    return; // Stop if validation fails
  }

  isSending.value = true;
  try {
    if (!message.value.trim()) {
      message.value = `I am interested in this property. Please send me current availability and additional details.`;
    }

    const requestBody = {
      email: email.value,
      phone: phone.value,
      description: message.value,
      name: name.value,
      pets: pets.value,
      isWorking: isWorking.value,
      employerDetails: isWorking.value === 'yes' ? employerDetails.value : 'N/A',
      address: props.property.loction // This line is now safe
    };

    const response = await fetch(process.env.VUE_APP_sendEmailURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) throw new Error("Network response was not ok.");

    // 3. Show SweetAlert success modal
    Swal.fire({
      title: "Success!",
      text: "Your message has been sent successfully.",
      icon: "success",
      confirmButtonText: "OK",
    });

    // Reset form
    name.value = "";
    email.value = "";
    phone.value = "";
    message.value = "";
    gdprAgreement.value = false;
  } catch (error) {
    console.error("Error sending message:", error);
    // 4. Show SweetAlert error modal
    Swal.fire({
      title: "Error!",
      text: "Failed to send the message. Please try again.",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    isSending.value = false;
  }
};
</script>

<style scoped>
.invalid-feedback {
  /* Using !important to ensure the style is applied */
  display: block !important;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545; /* Bootstrap's default error color */
}

/* Optional: Make the red border on the input more prominent */
.form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}
.facebook-icon {
  background-color: white; /* White background */
  /* border-radius: 100%;  */
  padding: 2px;
  /* display: inline-block; Ensure proper alignment */
  color: #1877f2; /* Facebook blue color */
  text-align: center;
}

.facebook-icon i {
  font-size: 20px; /* Adjust icon size */
}
.teamgrid-social {
  display: flex; /* Use flexbox for alignment */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  width: 100%; /* Ensure it takes the full width of the parent */
}
</style>
